export default {"src":"https://web.cdn.greenlight.com/2.1415.0/_next/static/media/pin-icon.c6114843.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};